import React from 'react';

const FeedSkeleton = () => {
  return (
    <div className="bg-white hover:shadow-md transition-all duration-300 mb-0 sm:mb-6 overflow-hidden w-full mx-auto border border-transparent sm:border sm:border-gray-100 sm:rounded-xl animate-pulse">
      {/* Post Header Skeleton */}
      <div className="p-4 h-20 flex items-center">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-3">
            {/* Avatar Skeleton */}
            <div className="w-10 h-10 bg-gray-200 rounded-full flex-shrink-0"></div>
            
            {/* User Info Skeleton */}
            <div className="space-y-2">
              <div className="h-3 bg-gray-200 rounded w-24"></div>
              <div className="h-2 bg-gray-200 rounded w-16"></div>
            </div>
          </div>
          
          {/* More Options Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-gray-200 rounded-full"></div>
          </div>
        </div>
      </div>

      {/* Post Content Skeleton */}
      <div className="px-4 pb-2">
        <div className="bg-gray-200 rounded-xl max-[552px]:rounded-none p-5 h-72 flex flex-col space-y-3">
          {/* Title Skeleton */}
          <div className="space-y-2">
            <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            <div className="h-4 bg-gray-300 rounded w-1/2"></div>
          </div>
          
          {/* Content Lines Skeleton */}
          <div className="flex-1 space-y-2">
            <div className="h-3 bg-gray-300 rounded w-full"></div>
            <div className="h-3 bg-gray-300 rounded w-full"></div>
            <div className="h-3 bg-gray-300 rounded w-5/6"></div>
            <div className="h-3 bg-gray-300 rounded w-full"></div>
            <div className="h-3 bg-gray-300 rounded w-4/5"></div>
            <div className="h-3 bg-gray-300 rounded w-full"></div>
            <div className="h-3 bg-gray-300 rounded w-3/4"></div>
          </div>
        </div>
      </div>

      {/* Post Stats Skeleton */}
      <div className="px-4 py-2 border-t border-gray-100">
        <div className="flex items-center justify-between text-xs">
          <div className="flex items-center gap-3">
            <div className="h-3 bg-gray-200 rounded w-16"></div>
            <div className="h-3 bg-gray-200 rounded w-20"></div>
          </div>
          <div className="h-3 bg-gray-200 rounded w-16"></div>
        </div>
      </div>

      {/* Post Actions Skeleton */}
      <div className="px-4 py-3 border-t border-gray-100">
        <div className="flex items-center justify-between">
          {/* Left Actions */}
          <div className="flex items-center gap-4">
            <div className="w-5 h-5 bg-gray-200 rounded"></div>
            <div className="w-5 h-5 bg-gray-200 rounded"></div>
            <div className="w-5 h-5 bg-gray-200 rounded"></div>
          </div>
          
          {/* Right Action */}
          <div className="w-5 h-5 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
};

// Component to show multiple skeleton posts
const FeedSkeletonList = ({ count = 3 }) => {
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <FeedSkeleton key={index} />
      ))}
    </>
  );
};

export { FeedSkeleton, FeedSkeletonList };
export default FeedSkeleton;